<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="550"
    >
      <v-card>
         <v-card-text class="text-center">
           <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
<!--          正常に登録されました。<br> -->
           <p v-html="successText"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="amber darken-1"
            rounded
            block
            @click="showDialog()"
            class="black--text mb-5"
          >
            {{ buttonName }}戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["successUrl","successText"],
    data: () => ({
        isSuccessed: false,
        buttonName: ''
    }),
    methods: {
      showDialog() {
          this.isSuccessed = false
          this.$router.push(this.successUrl)
      },
      open() {
        if (this.successUrl == '/mymachinelist') {
          this.buttonName = "マイ機器一覧へ"
        } else if (this.successUrl == '/employeeList') {
          this.buttonName = "担当者一覧へ"
        } else {
          this.buttonName = "お申込みページへ"
        }
        this.isSuccessed = true
      }
    }
}
</script>

